module.exports = __webpack_public_path__ + "static/media/video-santa-fe.e305bb00.mp4";